<div 
  class="view-column-toggle"
  @show
  (click)="handleToggleClick()"
  *ngIf="isVisible()">
  <app-icon [icon]="isIn ? 'caret-right' : 'caret-left'"></app-icon>
</div>